import { downloadExcel } from '../download.helpers';

export const exportSuccessHelper = (response: any) => {
  const fileName = response.headers['content-type'].split('filename=')[1];
  downloadExcel(response, fileName);
};
